import { render, staticRenderFns } from "./DocumentList.component.pug?vue&type=template&id=68f86acf&scoped=true&lang=pug&"
import script from "./DocumentList.component.ts?vue&type=script&lang=ts&"
export * from "./DocumentList.component.ts?vue&type=script&lang=ts&"
import style0 from "./DocumentList.component.scss?vue&type=style&index=0&id=68f86acf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68f86acf",
  null
  
)

export default component.exports